module.exports = __webpack_public_path__ + "img/no-photo.3405c390.png";